"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (arr, key) {
    var result = {};
    arr.forEach(function (ele) {
        var kv = ele[key];
        if (!result[kv]) {
            result[kv] = [];
        }
        result[kv].push(ele);
    });
    return result;
};


//////////////////
// WEBPACK FOOTER
// ./~/binary-utils/lib/object/groupByKey.js
// module id = 4
// module chunks = 0